import React, {useEffect} from "react";
import { Link } from "react-router-dom";
import { Header, Sidebar } from "../Layout";
import Loading from "../shared/Loading";
import Objectives from "./Components/Objectives";
import Background from "./Components/Background";
import Audience from "./Components/Audience";
import Timeline from './Components/Timeline'
import SupportingDocs from './Components/SupportingDocs'
// import RelatedCampaigns from './Components/RelatedCampaigns'
import Details from './Components/Details'
import Chat from './Chat'
import { useDispatch, useSelector } from "react-redux";
import { getProjectMembers, getCampaignList, editProject, getObjectiveTypes, getAudienceTypes} from '../../actions/projectActions'
import { getPartners, getPartnersOptions} from '../../actions/partnerActions'
import { loadBackground } from '../../actions/backgroundActions'
import { loadObjectives } from '../../actions/objectivesActions'
import { loadAudience } from '../../actions/audienceActions'
import { loadProjectTimeline } from '../../actions/projectTimelineActions'
import { loadSupportingDocs } from '../../actions/supportingDocsActions'

const UpdateProject = (props) => {

      const dispatch = useDispatch();
      const { project, loading , members, objectiveTypes, audienceTypes} = useSelector(state => state.projectStore);
      const { projectBackground } = useSelector(state => state.backgroundStore);
      const { projectObjectives } = useSelector(state => state.objectivesStore);
      const { projectAudiences } = useSelector(state => state.audiencesStore);
      const { projectTimelines } = useSelector(state => state.timelinesStore)
      const { projectSupportingDocs } = useSelector(state => state.documentsStore)

    useEffect(() => {
        dispatch(getCampaignList(props.match.params.id))
        dispatch(getPartners())
        dispatch(getPartnersOptions())
        dispatch(getObjectiveTypes())
        dispatch(getAudienceTypes())
        dispatch(editProject(props.match.params.id))
        dispatch(getProjectMembers(props.match.params.id))
        dispatch(loadBackground(props.match.params.id));
        dispatch(loadObjectives(props.match.params.id));
        dispatch(loadAudience(props.match.params.id));
        dispatch(loadProjectTimeline(props.match.params.id));
        dispatch(loadSupportingDocs(props.match.params.id));

    }, [dispatch, props])

    useEffect(() => {
      if (projectTimelines) {
        
    //    console.log('inside project',projectTimelines);
      }
    },[project, members, objectiveTypes ,audienceTypes, projectBackground, projectAudiences, projectTimelines, projectSupportingDocs])
    
    if (loading) {
      <Loading />
    }
    return (
        <>
            <Header />
            <Sidebar />
            <div id="main-content">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Project Update</h2>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                                <li className="breadcrumb-item active">Projects</li>
                                <li className="breadcrumb-item active">Project Update</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row clearfix">

                        <div className="col-lg-12 col-md-12">
                            <div className="card">
                                <div className="header">
                                    {/* <h3>Q3 Video Assets </h3>
                                    <div className="header-dropdown dropdown dropdown-animated scale-left">
                                       <h3>Q94375</h3>
                                    </div> */}
                                </div>
                                <div className="body">
                                    <ul className="row nav nav-tabs">
                                        <li className="nav-item"><a className="nav-link text-center active show" data-toggle="tab" href="#Details">Details</a></li>
                                        {/* <li className="nav-item"><a className="nav-link text-center" data-toggle="tab" href="#Profile">WorkingGroup</a></li> */}
                                        <li className="nav-item"><a className="nav-link text-center" data-toggle="tab" href="#Background">Background</a></li>
                                        <li className="nav-item"><a className="nav-link text-center" data-toggle="tab" href="#Objectives">Objectives</a></li>
                                        <li className="nav-item"><a className="nav-link text-center" data-toggle="tab" href="#Audience">Audience</a></li>
                                        <li className="nav-item"><a className="nav-link text-center" data-toggle="tab" href="#Timeline">Timeline</a></li>
                                        <li className="nav-item"><a className="nav-link text-center" data-toggle="tab" href="#SupportingDocs">SupportingDocs</a></li>
                                        {/* <li className="nav-item"><a className="nav-link text-center" data-toggle="tab" href="#RelatedCampaigns">Related Campaigns</a></li> */}
                                        <li className="nav-item"><a className="nav-link text-center" data-toggle="tab" href="#Chat">Chat</a></li>
                                    </ul>
                                    <div className="tab-content mt-5">
                                        <div className="tab-pane show active" id="Details">
                                           {project === 'undefined' ? <Loading /> : <Details data={project}/> } 
                                        </div>
                                        <div className="tab-pane" id="Background">
                                            <Background data={project} background={projectBackground} members={members} />
                                        </div>
                                        <div className="tab-pane" id="Objectives">
                                            <Objectives data={project} members={members} objectives={projectObjectives} objectiveTypes={objectiveTypes} />
                                        </div>
                                        <div className="tab-pane" id="Audience">
                                            {/* tab body */}
                                            <Audience data={project} members={members} audienceTypes={audienceTypes} audiences={projectAudiences} />
                                        </div>
                                        <div className="tab-pane" id="Timeline">
                                            {/* tab body */}
                                            <Timeline data={project} members={members} timelines={projectTimelines} />
                                        </div>
                                        <div className="tab-pane" id="SupportingDocs">
                                            {/* tab body */}
                                            <SupportingDocs data={project} members={members} documents={projectSupportingDocs} />
                                        </div>
                                        {/* <div className="tab-pane" id="RelatedCampaigns">
                                            <RelatedCampaigns data={project} members={members} />
                                        </div> */}
                                        <div className="tab-pane" id="Chat">
                                            {/* tab body */}
                                            <Chat data={project} members={members} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    );
}
export default UpdateProject;